import { useCaseNumberInUse } from '../api/queries'

/**
 * Kundens eget sagsnummer i en formular (beslutning 083).
 *
 * <p>
 * <b>Valgfrit.</b> Lades feltet tomt, danner serveren nummeret af ordrenummeret,
 * så en sag aldrig står helt uden - og det siges under feltet, så ingen tror,
 * de har glemt noget.
 * </p>
 *
 * <p>
 * <b>Advarslen spærrer ikke.</b> En kunde kan sagtens bestille to ting på én
 * rekvisition, og så er det rigtigt, at nummeret står to steder. Men er det en
 * tastefejl, er det her, den skal fanges - ikke når fakturaen kommer retur.
 * </p>
 */
export function CaseNumberField({
  value,
  onChange,
  customerId,
  orderNumber,
  projectId
}: {
  value: string
  onChange: (value: string) => void
  customerId: number | null
  /** Det, nummeret bliver til, hvis feltet står tomt. */
  orderNumber: string
  /** Sagen, nummeret rettes på. Udelades ved oprettelse. */
  projectId?: number
}) {
  const { data } = useCaseNumberInUse(value, customerId, projectId)
  const alsoOn = data?.projects ?? []

  return (
    <label className="field">
      <span className="field__label">Kundens sagsnummer</span>
      <input
        placeholder="Det nummer kunden selv kører med"
        maxLength={50}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      {alsoOn.length > 0 ? (
        <span className="tiny warn">
          Kunden kører allerede {alsoOn.length === 1 ? 'sagen' : 'sagerne'}{' '}
          {alsoOn.map((name) => `"${name}"`).join(', ')} på det nummer. Det kan være rigtigt - to ting
          på én rekvisition - men tjek, at det ikke er en tastefejl.
        </span>
      ) : (
        <span className="tiny muted">
          {value.trim()
            ? 'Kundens eget nummer. Det er dét, der skal stå, når kunden spørger til sagen.'
            : orderNumber.trim()
              ? `Lades det tomt, kører sagen på vores eget ordrenummer ${orderNumber.trim()}.`
              : 'Lades det tomt, kører sagen på vores eget ordrenummer.'}
        </span>
      )}
    </label>
  )
}
